<template>
	<el-container>
		<div class="colhead">
			<h2 class="header_h2">产品管理</h2>
		</div>
		<el-header>
			
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="产品名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		<span style="float: left;">&emsp;选择企业：</span> 
		<el-select style="float: left; width: 200px;  height:30px;" v-model="curcorpid" v-on:change="getAllData">
					<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id" placeholder="请选择">
						{{ item.corp_name }}
					</el-option>
				</el-select>
		</el-header>
		<el-main>
			
			<el-table border ref="multipleTable" tooltip-effect="dark"  :data="MyData.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<!-- <el-table-column type="selection"></el-table-column> -->
				<el-table-column prop="IsValid" label="是否有效" width="60px">
					<template slot-scope="scope">
						<label v-if='scope.row.IsValid=="0"'>否</label>
						<label v-if='scope.row.IsValid=="1"'>是</label>
					</template>
				</el-table-column>
				<el-table-column prop="SaleModuleID" label="产品编号" width="200px"></el-table-column>
				<el-table-column prop="SaleModuleName" label="产品名称" width="300px"></el-table-column>
				<el-table-column prop="AdaptSex" label="适用性别" width="100%">
					<template slot-scope="scope">
						<label v-if='scope.row.AdaptSex=="3"'>不限</label>
						<label v-if='scope.row.AdaptSex=="1"'>男</label>
						<label v-if='scope.row.AdaptSex=="2"'>女</label>
					</template>
				</el-table-column>
				<el-table-column prop="MiniDiscount" label="最低折扣"></el-table-column>
				<el-table-column prop="CurPrice" label="售价"></el-table-column>
				<el-table-column prop="Discount" label="折扣"></el-table-column>
				<el-table-column prop="OrgPrice" label="原价"></el-table-column>
				<el-table-column prop="ShowOrder" label="排序"></el-table-column>
				<el-table-column prop="EmpName" label="操作员"></el-table-column>
				<el-table-column prop="EmpDate" label="操作时间" width="120px"></el-table-column>
				<el-table-column label="操作"  fixed="right" width="120px">
					<template slot-scope="scope">
						<!-- <el-button @click="handleClick(scope.$index,scope.row)" icon="el-icon-bottom" type="text" size="small">查看</el-button> -->
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
						<!-- <el-button @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" type="text" size="small">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="启用:">
				    <el-switch v-model="EditInfo.IsValid" active-value="1" inactive-value="0"></el-switch>
				  </el-form-item>
				<el-form-item label="产品编号">
					<el-input v-model="EditInfo.SaleModuleID"></el-input>
				</el-form-item>
				<el-form-item label="产品名称">
					<el-input  v-model="EditInfo.SaleModuleName"></el-input>
				</el-form-item>
				<!-- <el-form-item label="适用性别">
					<select style=" width: 100px;  height:30px;" v-model="EditInfo.AdaptSex">
						<option v-for="item in AdaptSex" :value="item.value">
							<h2>{{ item.key }}</h2>
						</option>
					</select>
				</el-form-item> -->
				<el-form-item label="适用性别" >
				    <el-select v-model="EditInfo.AdaptSex" placeholder="请选择" style="width: 100px;">
				      <el-option v-for="item in AdaptSex" :label="item.key" :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="最低折扣">
					<el-input type='number' size="medium" v-model.trim="EditInfo.MiniDiscount" placeholder="最低折扣"></el-input>
				</el-form-item>
				<el-form-item label="售价">
					<el-input type='number' size="medium" v-model.trim="EditInfo.CurPrice" placeholder="售价"></el-input>
				</el-form-item>
				<el-form-item label="折扣">
					<el-input type='number' size="medium" v-model.trim="EditInfo.Discount" placeholder="折扣"></el-input>
				</el-form-item>
				<el-form-item type='number' label="原价">
					<el-input size="medium" v-model.trim="EditInfo.OrgPrice" placeholder="原价"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input type='number' v-model.trim="EditInfo.ShowOrder" placeholder="排序号"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<!-- <el-form-item label="启用">
					<el-checkbox v-model="AddInfo.IsValid" :true-label="1" :false-label="0"></el-checkbox>
				</el-form-item> -->
				<el-form-item label="启用:">
				    <el-switch v-model="AddInfo.IsValid" active-value="1" inactive-value="0"></el-switch>
				  </el-form-item>
				<el-form-item label="产品编号:">
				  <el-input v-model="AddInfo.SaleModuleID"></el-input>
				</el-form-item>
				<!-- <el-form-item label="检查模块编号">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.CheckModuleID"></el-input>
				</el-form-item> -->
				<el-form-item label="产品名称">
					<el-input  v-model="AddInfo.SaleModuleName"></el-input>
				</el-form-item>
				<el-form-item label="适用性别">
				    <el-select v-model="AddInfo.AdaptSex" placeholder="请选择" style="width: 100%;">
				      <el-option v-for="item in AdaptSex" :label="item.key" :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<!-- <el-form-item label="适用性别">
					<select style=" width: 100px;  height:30px;" v-model="AddInfo.AdaptSex">
						<option v-for="item in AdaptSex" :value="item.value">
							<h2>{{ item.key }}</h2>
						</option>
					</select>
				</el-form-item> -->
				<el-form-item label="最低折扣">
					<el-input size="medium" v-model.trim="AddInfo.MiniDiscount" placeholder="最低折扣" type='number'></el-input>
				</el-form-item>
				<el-form-item label="售价">
					<el-input size="medium" v-model.trim="AddInfo.CurPrice" placeholder="售价" type='number'></el-input>
				</el-form-item>
				<el-form-item label="折扣">
					<el-input size="medium" v-model.trim="AddInfo.Discount" placeholder="折扣" type='number'></el-input>
				</el-form-item>
				<el-form-item label="原价">
					<el-input size="medium" v-model.trim="AddInfo.OrgPrice" placeholder="原价" type='number'></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input v-model.trim="AddInfo.ShowOrder" placeholder="排序号" type='number'></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
				    <el-button type="primary" @click.native="bao1AddSure">确定</el-button>
				    <el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-container>
</template>



<script>
	// import Vue from 'vue'
	import enums from '../../commontools/enums.js'
	import SaleModule from '../../apifunction/SaleModule.js'
	import corp from '../../apifunction/Corp.js'
	export default {
		data() {
			return {
				CorpData: [],
				curcorpid:'',
				MyData: [],
				AdaptSex: enums.AdaptSex,
				currentPage: 1,
				pagesize: 10,
				bao1look: false,
				bao1edit: false,
				bao1detele: false,
				bao1newadd: false,
				idx: null,
				deleteAll: [],
				del_list: [],
				//   通过姓名查询
				select_word: "",
				//   定义初始个人信息
				EditInfo: {
					SaleModuleID:'',
					SaleModuleName: '',
					BriefName: '',
					MiniDiscount: 0,
					FNote: '',
					Discount:1,
					OrgPrice:0,
					IsValid: '1',
					CurPrice: 0,
					ShowOrder: 0,
					AdaptSex:'0',
					ModuleType:4,
					CorpID:this.curcorpid,
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				},
				AddInfo: {
					SaleModuleID:'',
					SaleModuleName: '',
					BriefName: '',
					MiniDiscount: 0,
					FNote: '',
					Discount:1,
					OrgPrice:0,
					IsValid: '1',
					CurPrice: 0,
					ShowOrder: 0,
					AdaptSex:'0',
					ModuleType:4,
					CorpID:this.curcorpid,
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				}
			};
		},
		mounted() {
			//this.getAllData();
			this.getAllCorp();
		},
		methods: {
			getAllCorp() {
				corp.GetAllCorp()
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if(ent.Data!='null')
							this.CorpData = JSON.parse(ent.Data);
			
			
						} else
							this.$message.info(ent.Msg);
					})
			},
			//   得到所有的数据---------------
			getAllData() {
				if(this.curcorpid=='')
				return;
				SaleModule.GetSaleModuleAll(this.curcorpid)
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data))
					if (ent.Flag=='success') {
						if(ent.Data!='null')
						this.MyData =JSON.parse(ent.Data)
						else
						this.MyData =[];
					} else
						this.$message.info(ent.Msg);
				})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				// alert(row.IsValid);
				this.EditInfo = {
					SaleModuleID:row.SaleModuleID,
					SaleModuleName:  row.SaleModuleName,
					BriefName: row.BriefName,
					MiniDiscount: row.MiniDiscount,
					FNote: row.FNote,
					Discount:row.Discount,
					OrgPrice:row.OrgPrice,
					IsValid: row.IsValid,
					CurPrice: row.CurPrice,
					ShowOrder: row.ShowOrder,
					AdaptSex:row.AdaptSex,
					ModuleType:row.ModuleType,
					CorpID:row.CorpID,
					EmpID: row.EmpID,
					EmpName: row.EmpName,
					EmpDate: row.EmpDate
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				this.EditInfo.EmpID = this.$myglobal.getUserInfo().id;
				this.EditInfo.EmpName = this.$myglobal.getUserInfo().username;
				this.EditInfo.EmpDate = this.CommonFun.GetNowDateTime();
				SaleModule.EditSaleModule(this.EditInfo)
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						this.MyData.splice(this.idx,1,this.EditInfo)
						this.bao1edit = false;
						this.$message.success("修改成功");
						
					} else
						this.$message.info(ent.Msg);
				})
				
			},
			// 新增按钮-----
			baonewAdd() {
				
				if(this.curcorpid=='')
				{
					this.$message.info("请选择要添加产品的企业！");
					return;
				}
				this.bao1newadd = true;
				this.AddInfo={
					SaleModuleID:'',
					SaleModuleName: '',
					BriefName: '',
					MiniDiscount: 0,
					FNote: '',
					Discount:1,
					OrgPrice:0,
					IsValid: '1',
					CurPrice: 0,
					ShowOrder: 0,
					AdaptSex:'3',
					ModuleType:4,
					CorpID:this.curcorpid,
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				}
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				if(this.AddInfo.SaleModuleID==''||this.AddInfo.SaleModuleName=='')
				{
					this.$message.info("‘销售模块编号’和‘销售模块名称’不能为空");
					return;
				}
				let user=this.$myglobal.getUserInfo();
				this.AddInfo.EmpID =user.id;
				this.AddInfo.EmpName =user.username;
				this.AddInfo.EmpDate = this.CommonFun.GetNowDate();
				this.AddInfo.CorpID = this.curcorpid;
				SaleModule.AddSaleModule(this.AddInfo)
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						this.data.unshift(this.AddInfo);
						this.bao1newadd = false;
						this.$message.success("新增成功");
						
					} else
						this.$message.info(ent.Msg);
				})
				
				
			},
			// 当用户手动勾选数据行的 Checkbox 时触发的事件, 将所有的勾选的数据集中到一个数组中
			// select(selection, row) {
			// 	this.deleteAll = selection;
			// }
		},
		computed: {
			data() {
				return this.MyData.filter(item => {
					// return item;
					let is_del = false;
					for (let i = 0; i < this.del_list.length; i++) {
						if (item.SaleModuleName === this.del_list[i].SaleModuleName) {
							is_del = true;
							break;
						}
					}
					if (!is_del) {
						if (item.SaleModuleName.indexOf(this.select_word) > -1) {
							return item;
						}
					}
				});
			}
		}
	};
</script>



